import { ServiceIndustry } from "@/lib/types";

export const serviceIndustries: ServiceIndustry[] = [
  {
    number: "01",
    title: "Fashion & Marketplace",
    description:
      "Product discovery, click-depth and mobile flow decide the sale. Imagery leads, interface gets out of the way.",
    proof: "Chic & Charming — UI/UX, Web Solutions",
  },
  {
    number: "02",
    title: "Luxury E-Commerce",
    description:
      "Authenticity is the purchase decision. Trust design, provenance and checkout confidence carry more weight than discounting.",
    proof: "Elorva Perfumes — Brand, Web Solutions",
  },
  {
    number: "03",
    title: "SaaS & Startups",
    description:
      "One page often carries the whole funnel. Positioning, proof and speed do more for signups than a longer feature list.",
    proof: "Moson Media — Web, Visual Story",
  },
  {
    number: "04",
    title: "Media & Production",
    description:
      "The site has to hold the standard of the reel it is selling. Motion, grade and pacing are part of the interface, not decoration.",
    proof: "Artevic Media — Brand, Web, Video",
  },
  {
    number: "05",
    title: "AI & Automation",
    description:
      "Explaining what the product actually does beats naming the model. Clear flows and honest demos convert non-technical buyers.",
    proof: "SaaS Product — Product, Engineering",
  },
  {
    number: "06",
    title: "Agencies & Studios",
    description:
      "Your site is your portfolio piece. It has to survive being judged by people who design for a living.",
    proof: "Full engagement — Brand, Web, Video",
  },
];
